import React, { useState } from "react"; // Styles

import "./button.styles.scss";

function Button({
  menu = [],
  defaultClick = () => {},
  tooltip,
  wrapperClassname = "",
  iconClassname = ""
}) {
  const [showMenu, setShowMenu] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: `react__pdf--button ${wrapperClassname}`
  }, /*#__PURE__*/React.createElement("i", {
    onClick: defaultClick,
    "data-tip": tooltip,
    className: iconClassname
  }), menu && /*#__PURE__*/React.createElement("div", {
    className: "react__pdf--button-arrow ml-5"
  }, /*#__PURE__*/React.createElement("i", {
    onClick: () => setShowMenu(!showMenu),
    className: "fas fa-caret-down pointer"
  })), menu && showMenu && /*#__PURE__*/React.createElement("div", {
    className: "react__pdf--button-menu"
  }, menu.map((item, idx) => /*#__PURE__*/React.createElement("div", {
    key: idx,
    onClick: () => {
      setShowMenu(!showMenu);
      item.onClick();
    },
    className: "react__pdf--button-menu-item pointer"
  }, item.label))));
}

export default Button;